import { useCallback, useRef, useEffect } from 'react';
import { CACHE_DEBOUNCE_DELAY } from '../constants/campaignSelect';
export function useDebounceCallback(callback, delay = CACHE_DEBOUNCE_DELAY) {
  const timeoutRef = useRef(null);
  const callbackRef = useRef(callback);
  // eslint-disable-next-line react-hooks/refs
  callbackRef.current = callback;
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  return useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      callbackRef.current();
      timeoutRef.current = null;
    }, delay);
  }, [delay]);
}